import { css } from "@compiled/react";
import { useIntl } from "react-intl";

import { media } from "@atlaskit/primitives";
import { token } from "@atlaskit/tokens";

import { Adg4Button } from "@/components/adg4/button/src";
import { Picture } from "@/components/wpl/image/src";
import { wacToken } from "@/libraries/design/foundations";
import { useLocalizedHref } from "@/libraries/web-framework";
import { Row } from "@/libraries/wpl/foundations/src";

const bannerStyle = css({
    background: wacToken("color.primary.lime"),
    borderRadius: wacToken("corner.radius.card"),
    display: "grid",
    gridTemplateColumns: "1fr",
    placeItems: "center",
    gap: token("space.300"),
    width: "100%",
    paddingBlockStart: token("space.400"),
    paddingInline: token("space.200"),
    marginBlockEnd: token("space.400"),
    textAlign: "center",
    [media.above.sm]: {
        justifyItems: "stretch",
        textAlign: "start",
        gridTemplateColumns: "1fr 1fr max-content",
        paddingBlock: token("space.0"),
        paddingInline: token("space.400")
    },
    [media.only.lg]: {
        gridTemplateColumns: "1fr 1fr .75fr"
    },
    [media.only.xl]: {
        gridTemplateColumns: "1fr 1fr .75fr"
    }
});
const imgStyle = css({
    display: "flex",
    alignSelf: "flex-end",
    maxWidth: "100%",
    [media.above.sm]: {
        gridRowStart: 1,
        gridColumnStart: 2
    },
    // Need to style img inside picture element
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    img: {
        maxWidth: "100%",
        height: "auto"
    }
});
const buttonStyle = css({
    justifySelf: "center"
});

const DemoBanner = () => {
    const intl = useIntl();

    return (
        <Row layout="12">
            <div css={bannerStyle}>
                <p className="h3">
                    {intl.formatMessage({
                        id: "JiraProductDiscoveryPage.demo.body.text",
                        defaultMessage: "Join our demo with live chat Q&A"
                    })}
                </p>
                <Adg4Button
                    variant="secondary"
                    color="black"
                    href={useLocalizedHref(
                        "/software/jira/product-discovery/demo"
                    )}
                    dataEventProps={{
                        "data-event": "clicked",
                        "data-event-container": "banner-link-button",
                        "data-event-component": "linkButton",
                        "data-product-key": "jiraProductDiscovery"
                    }}
                    css={buttonStyle}
                >
                    {intl.formatMessage({
                        id: "JiraProductDiscoveryPage.demo.cta.text",
                        defaultMessage: "Register now"
                    })}
                </Adg4Button>
                <Picture
                    image={{
                        src: "https://dam-cdn.atl.orangelogic.com/AssetLink/ua18axib18162bej4n515osj7675wepi.webp",
                        alt: intl.formatMessage({
                            id: "JiraProductDiscoveryPage.demo.screenshot.alt",
                            defaultMessage:
                                "Screenshot of Jira Product Discovery"
                        }),
                        width: 368,
                        height: 154
                    }}
                    css={imgStyle}
                />
            </div>
        </Row>
    );
};

export default DemoBanner;
